interface AssetSubtype {
  id?: number;
  name?: string;
  companyId?: number;
  typeId?: number;
}

export const newAssetSubtype = (): AssetSubtype => {
  return {};
};

export default AssetSubtype;
